import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { CatIconPeople } from '@blocks-react/components/Icons/People';
import { CatIconLock } from '@blocks-react/components/Icons/Lock';
import { CatIconDealer } from '@blocks-react/components/Icons/Dealer';
import { CatButton } from '@blocks-react/components/Button';
import { DEALER } from '@app/constants/affiliations';
import styles from './ListTypeHeader.module.scss';
import { BUTTON_SIZES, BUTTON_VARIANTS } from '@app/constants/commonConstants';

const ListTypeHeader = () => {
  const { t } = useTranslation();
  const userAffiliation = useSelector(s => s.common?.userAffiliation);
  const isDealerUser = userAffiliation === DEALER;
  const listTypeTooltipInfo = isDealerUser
    ? [
        { id: 'shared', icon: <CatIconPeople />, title: 'SHARED' },
        {
          icon: <CatIconLock />,
          title: 'REQUISITIONLIST_TYPE_PRIVATE',
          className: 'mb-0',
          id: 'private'
        }
      ]
    : [
        {
          id: 'private',
          icon: <CatIconLock />,
          title: 'REQUISITIONLIST_TYPE_PRIVATE'
        },
        {
          id: 'public',
          icon: <CatIconPeople />,
          title: 'PUBLIC'
        },
        {
          icon: <CatIconDealer />,
          title: 'REQUISITIONLIST_TYPE_DEALER',
          className: 'mb-0',
          id: 'dealer'
        }
      ];
  return (
    <div>
      <CatTooltip position="bottom">
        <CatButton
          slot="trigger"
          size={BUTTON_SIZES.SM}
          hideText={true}
          variant={BUTTON_VARIANTS.GHOST}
        >
          <CatIconInfo slot="after"></CatIconInfo>
        </CatButton>
        <div className={`${styles['tooltip-width']}`}>
          {listTypeTooltipInfo.map(item => {
            return (
              <p className={`d-flex ${item.className}`} key={item.id}>
                <span className="pe-2">{item.icon}</span>
                {t(item.title)}
              </p>
            );
          })}
        </div>
      </CatTooltip>
    </div>
  );
};

export default ListTypeHeader;
